<template>
    <div>

        <workspace-header :providedSecondaryTitle="selectedSample.name"
                          :sampleOnly="isSampleOnly" :isTpg="isTpg"></workspace-header>

        <div class="workspace-content">
            <div class="workspace-content-fluid-row">
                    <div class="col">

                        <div class="sample-playlist">

                            <div class="options-row">
                                <div class="col-xs-6">
                                    <div class="sample-play-button" @click="playSample()" :class="{isTpg:isTpg}">
                                        <div v-if="playerState == 'playing' && selectedSample.json_playlist_url == playlistUrl">
                                                &nbsp;&nbsp;PAUSE
                                        </div>
                                        <div v-else>
                                            &nbsp;&nbsp;PLAY
                                        </div>
                                    </div>
                                    <font-awesome-icon icon="random" aria-hidden="false" class="shuffle-tracks"
                                          :class="{isTpg:isTpg}"
                                        @click="shuffleTracks"
                                        title="Shuffle tracks"
                                        v-if="selectedSample && selectedSample.clientweb_shuffle == 1" />

                                </div>

                                <div class="shortclip-checkbox col-xs-6">

                                    <div v-if="selectedSample && selectedSample.short_clip_playback_type_id == '2'">

                                    <div class="">
                                      <div class="dropdown-toggle gv-drop" @click="showShortClipDrop = !showShortClipDrop" :class="{isTpg:isTpg}">
                                        {{shortClipText}}
                                        <!-- <font-awesome-icon icon="caret-down"  aria-hidden="false" /> -->
                                      </div>
                                      <div class="dropdown-menu-right" v-if="showShortClipDrop">
                                        <div class="gv-drop-item"
                                            @click="updateShortClip('short'), showShortClipDrop = !showShortClipDrop"
                                            :class='{selectedDropDown: shortClipText == "Short Clips", isTpg:isTpg}'>Short Clips</div>
                                        <div class="gv-drop-item"
                                            @click="updateShortClip('full'), showShortClipDrop = !showShortClipDrop"
                                            :class='{selectedDropDown: shortClipText == "Full Tracks", isTpg:isTpg}'>Full Tracks</div>
                                      </div>
                                    </div>
                                     </div>
                                </div>
                            </div>

                             <div v-for="track in samplePlaylistAndVotes.slice(0, 15)"
                                    :key="track.code"
                                  class="row track-row" :class='{selectedPlaylistRow: currentTrack && track.code == currentTrack.code, isInteractiveRow: selectedSample.clientweb_interactive == 1, isTpg:isTpg}'>

                                <div class="col-xs-2 sample-image" @click='trackSelected(track)'>
                                    <img :src="track.cover" onerror="javascript:this.src='/images/unknown-album.jpg'">
                                    <span v-if="selectedSample.clientweb_interactive == 1">

                                    </span>
                                </div>

                                <div class="col-xs-9" @click="trackSelected(track)">
                                   <div class="title-artist-container">
                                     <div class="col-md-6 track-title" :title="track.title">{{ track.title }}</div>
                                     <div class="col-md-6 track-artist" :title="track.artist">{{ track.artist }}</div>
                                  </div>
                                </div>

                                <div class="col-xs-2 sample-vote-container">
                                    <div style="width:33%;float:right;">
                                        <div class="comment-on-vote sample-vote"
                                             v-if="selectedSample.clientweb_interactive == '1'"
                                             v-on:click="commentClicked(track)"
                                             :class="{voteSelected: (track && track.comment && (track.comment.length > 1) || track.vote_reason_id > 0),isTpg:isTpg}"></div>
                                    </div>
                                    <div style="width:33%;float:right;">
                                        <div class="vote-leave sample-vote"
                                             v-if="selectedSample.clientweb_interactive == '1'"
                                             v-on:click="sampleVoteClicked(track,'2')"
                                             :class="{voteSelected: track.override_type_id == '2',isTpg:isTpg}"></div>
                                    </div>

                                    <div style="width:33%;float:right;">
                                        <div class="vote-love sample-vote"
                                             v-if="selectedSample.clientweb_interactive == '1'"
                                             v-on:click="sampleVoteClicked(track,'1')"
                                             :class="{voteSelected: track.override_type_id == '1',isTpg:isTpg}"></div>
                                    </div>
                                </div>

                             </div>
                        </div>
                    </div>

                </div>
            </div>
    </div>
</template>

<script>
export default {
  props: ['player-state',
    'current-track',
    'playlist-url',
    'short-clip-playback-type-id',
    'user-has-access-to-at-least-one-player',
    'sample-playlist-and-votes',
    'selected-sample',
    'allow-voting',
    'is-tpg'],
  data() {
    return {
      samplePlaylist: '',
      userSelectedShortClip: '0',
      voteTypeString: '',
      hasPlayed: false,
      shortClipText: 'Short Clips',
      showShortClipDrop: false,
    };
  },
  mounted() {
    this.loadSamplePlaylist();
  },
  methods: {
    /**
            * Load the initial playlist. Gets all playlists then filters out selected playlist and sets samplePlaylist.
            */
    loadSamplePlaylist() {
      const sampleID = this.$route.params.id;
      const self = this;

      this.$http.get('/sample_playlists').then((response) => {
        const samples = response.data;

        for (let i = 0; i < samples.length; i++) {
          if (samples[i].id == sampleID) {
            self.samplePlaylist = samples[i];
          }
        }

        if (self.samplePlaylist) {
          self.$emit('fetchSamplePlaylist', self.samplePlaylist);
        }
      });
    },
    /**
            * Play button has been clicked.  If same list, then toggle.  Otherwise load new list.
            */
    playSample() {
      // Hack for Safari.
      if (this.hasPlayed == false) {
        // document.getElementById('playButton').click();
        this.hasPlayed = true;
      }

      this.$emit('samplePlayClick');
    },
    shuffleTracks() {
      this.$emit('shuffleSample');
    },
    updateShortClip(type) {
      if (type == 'short') {
        this.shortClipText = 'Short Clips';
        this.$emit('shortClipClicked', '1');
      } else if (type == 'full') {
        this.shortClipText = 'Full Tracks';
        this.$emit('shortClipClicked', '0');
      }
    },
    makeTrackObject(track) {
      const obj = {};
      obj.title = track.title;
      obj.code = track.code;
      obj.artist = track.artist;
      obj.file = track.file;
      obj.cover = track.cover;
      obj.genstamp = track.genstamp;
      obj.override_type_id = '';
      obj.vote_reason_id = '';
      obj.comment = '';

      return obj;
    },
    checkTrackVote(trackCode) {
      for (let i = 0; i < this.playlistVotes.length; i++) {
        if (this.playlistVotes[i].track_code == trackCode) {
          return this.playlistVotes[i].override_type_id;
        }
      }

      return false;
    },
    getSamplePlaylistVotes() {
      const self = this;
      this.$http.get(`/sample_playlists/${self.samplePlaylist.code}`).then((response) => {
        const votes = response.data;
        self.playlistVotes = votes;

        // add votes to the playlist
        self.addVotesToPlaylist();
      });
    },
    emitPlaylist() {
      const playlistURLAndContent = {
        url: this.samplePlaylist.json_playlist_url,
        tracks: this.playlistTracks.slice(0, 15),
        short_clip_playback_type_id: this.samplePlaylist.short_clip_playback_type_id,
        origin: `Sample: ${this.samplePlaylist.name}`,
        route: `/sample/${this.$route.params.id}`,
        clientweb_interactive: this.selectedSample.clientweb_interactive,
        allow_voting: '1',
        is_sample: '1',
      };

      this.$emit('playlistSelected', playlistURLAndContent);
      this.$emit('togglePlayPause');
    },
    /**
            * Checks if track has a vote in existingVotes
            *
            * @param object track
            * @return 1 (positive), 0 (negative), -1 (comment only)
            */
    addVotesToPlaylist() {
      // Go through
      const playlistWithVotes = [];
      for (let i = 0; i < this.playlistTracks.length; i++) {
        playlistWithVotes.push(this.playlistTracks[i]);
        for (const key in this.playlistVotes) {
          if (!Object.prototype.hasOwnProperty.call(this.playlistVotes, key)) continue;

          const obj = this.playlistVotes[key];
          if (obj.track_code === this.playlistTracks[i].code) {
            playlistWithVotes[i].override_type_id = obj.override_type_id;
            playlistWithVotes[i].comment = obj.comment;
          }
        }
      }

      this.playlistTracks = playlistWithVotes;
    },
    trackSelected(track) {
      if (track && track.code && this.selectedSample.clientweb_interactive == 1) {
        this.$emit('trackManuallySelected', track);

        // Hack for safari
        if (this.hasPlayed == false) {
          // document.getElementById('playButton').click();
          this.hasPlayed = true;
        }
      }
    },
    /**
            * Handle vote click. Checks if same as last and deletes accordingly
            *
            * @param object track, int loveOrLeave (love=1, leave=0)
            * @return this.makeVote()
            */
    sampleVoteClicked(track, loveOrLeave) {
      if (track.override_type_id == loveOrLeave) {
        this.$emit('sampleVoteClicked', track, loveOrLeave);
        for (let i = 0; i < this.samplePlaylistAndVotes.length; i++) {
          if (this.samplePlaylistAndVotes[i].code == track.code) {
            loveOrLeave = null;
            this.samplePlaylistAndVotes[i].override_type_id = loveOrLeave;
          }
        }

        track.override_type_id = loveOrLeave;
        return false;
      }

      this.$emit('sampleVoteClicked', track, loveOrLeave, this.samplePlaylist);
      track.override_type_id = loveOrLeave;
    },
    commentClicked(track) {
      this.$emit('voteCommentClicked', track);
    },
    /**
            * Needed to upodate DOM
            */
    reloadPlaylist() {
      // this.playlistTracks = this.playlistTracks;
    },

  },
  watch: {
    userSelectedShortClip() {
      if (this.userSelectedShortClip) {
        this.$emit('shortClipClicked', this.selectedSample.short_clip_playback_type_id);
      } else {
        this.$emit('shortClipClicked', 0);
      }
    },
  },
  computed: {
    isSampleOnly() {
      return false;
      // if (this.userHasAccessToAtLeastOnePlayer == true) {
      //     return false;
      // } else {
      //     return true;
      // }
    },
    shortClipButtonText() {
      return 'Short Clips';
    },
  },
};

</script>

<style scoped>
.track-row {
    height:40px;
}
.sample-vote-container {
    padding:0px;
    height:40px;
}
.isInteractiveRow {
    cursor: pointer;
}
.isInteractiveRow:hover {
    color:#ccc;
}
.isInteractiveRow.isTpg:hover {
    color:#000;
}
.sample-row-header {
    clear:left;
    padding-top:10px;
    padding-left:0px;
    padding-bottom: 5px;
    border-bottom:0px solid rgba(200,200,200,.6);
}
.title-artist-container {

    line-height: 20px;
}
.playlist {
    width: 100%;
    padding:2px;
    background-color: rgba(27, 27, 27, 0.7);
    border-radius: 4px;
    cursor: pointer;
    height:30px;
    margin-bottom: 10px;
}

.playlistText {
    width:80%;
    max-width:80%;
    float:left;
    overflow: hidden;
    text-overflow: fade(5%);
     white-space: nowrap;
    padding:5px;
}
.playlist-row {
    height:12px;
}
.playlist-play-button {
    float:right;
    width:50px;
    background:yellow;
    text-align: center;
    color:black;
    padding:1px;
    font-size:9px;
    margin-top:6px;
    margin-right:3px;
    border-radius: 3px;
}
.playlist-play-button.isTpg {
    background: #00c996;
}
@media (max-width:768px) {
    .playlist {
        width:280px;
    }
    .playlistText {
        width:210px;
        max-width:210px;
    }
    .playlist-play-button {
        width:40px;
    }
}
.selectedPlaylistRow {
    color:yellow;
    font-weight: bold;
}
.selectedPlaylistRow.isTpg {
    color: rgba(1,172, 129,1);
    font-weight: normal;
}
.track-row {
    border-top:1px solid rgba(200,200,200,.6);
}
.track-row div {
    margin-top:2px;
}
.track-row span {
    position: absolute;
    width:34px;
    height:34px;
    margin-left:3px;
    top:0px;
    opacity: 0;
    z-index: 5;
}

.track-row:hover span {
     opacity: .7;
}
.track-row.noIcon:hover span {
    opacity: 0;
    display:none;
}
.playlists-container {
/*    margin-left:-15px;*/
    width:100%;
}
.shuffle-tracks {
    cursor: pointer;
    padding-right:0px;
    color:white;
    transition: 0.3s;
    float:left;
    margin-top:5px;
    margin-left:15px;
}
.shuffle-tracks.isTpg {
    color:black;
}
.shuffle-tracks:hover {
    color:yellow;
}
.shuffle-tracks.isTpg:hover {
    color:#00c996;
}
.track-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.track-artist {
white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sample-image {
    float:left;
    width:34px;
    margin-right: 15px;
    margin-left:-15px;
}
.sample-image img {
    height:34px;
    width:34px;
    margin-top:-5px;
}

.sample-votes {
    float:right;
}

.vote-love.sample-vote,.vote-leave.sample-vote,.comment-on-vote.sample-vote {
  float:right;
  margin-top:-3px;
}
.vote-love {
    background-position: 0px -4px;
}
.vote-love.isTpg {
    background-position: 0px 0px;
}
.vote-love.voteSelected,.vote-love:hover {
    background-position: 0px 0px;
}
.comment-on-vote {
    background-position: 0px -4px;
}
.comment-on-vote.isTpg {
    background-position: 0px 0px;
}
@media (max-width:616px) {
    .sample-image img {
        height:52px;
        width:52px;
        margin-top:8px;
    }
        .sample-vote-container {
        top:-5px;
    }
    .title-artist-container {
        padding-top:8px;
    }
    .track-row span {
        margin-left:10px;
        top:16px;
    }

}
@media (max-width:992px) {
    .track-row {
    height:auto;
}
.sample-vote-container {
    height:30px;
    padding-top: 12px;
}

    .title-artist-container {
        top:-3px;
        position:relative;
    }
    .sample-image img {
        height:46px;
        width:46px;
    }
    .sample-votes{
        position: relative;
        top:-5px;
        right:-5px;
        float:right;
    }
    .vote-love {
        float:right;
    }
    .vote-leave {
        float:right;
    }
    .sample-vote-container {
        float:right;
        margin-top:-5px;
    }
}
.vote-comment {
    position: fixed;
    top:0;
    width:120px;
    left:50%;
    margin-left: -60px;
    background: white;
    color:black;
    font-weight:bold;
    cursor: pointer;
    height:0px;
    line-height: 30px;
    text-align: center;
    transition:.1s;
    visibility: hidden;
    z-index: 10;
}
.vote-comment.isVisible {
    height:30px;
    visibility: visible;
}
.shortclip-checkbox {
   color:black;
   text-align: right;
   margin-top:-10px;
   margin-right: -20px;
}
.sampleHeader {
    padding:0px;
    margin:0px;
    width:100%;
    clear:both;
}
.shuffle-container {
    line-height: 20px;
    height:20px;
    float: left;
}
.options-row {
    height:32px;
    width:100%;
    clear:both;
    padding-right:0px;
    padding-top:5px;
    padding-bottom: 5px;
}
.sample-play-button {
    font-size: 12px;
    float:left;
    width:80px;
    height:20px;
    line-height: 20px;
    padding-top:1px;
    cursor:pointer;
    text-align: center;
    color:#000;
    background:#ccc;
    transition: .3s;
    margin-left:-20px;
    margin-right: 0px;
}
.sample-play-button:hover {
    background:yellow;
}
.sample-play-button.isTpg:hover {
    background:#00c996;
}
.gv-drop {
    color:white;
    border:0px solid black;
    border-radius: 0;
    height:26px;
    cursor: pointer;
}
.gv-drop.isTpg {
    color:black;
}
.gv-drop-item {
    text-align: right;
    padding-right:10px;
    cursor: pointer;
    border-radius: 0;
    background: rgba(72,70,77,.9);
    color:white;
}
.gv-drop-item:hover {
    color:#efefef;
}
.dropdown-menu-right {
    position:absolute;
    width:120px;
    max-width:120px;
    background: rgba(72,70,77,.9);
    height:50px;
    z-index: 10;
}
.dropdown-menu {
    width:120px;
    max-width:120px;
    background: rgba(72,70,77,.9);
    height:300px;

}
.selectedDropDown {
    color:yellow;
}
.selectedDropDown.isTpg {
    color:#00c996;
}
.gv-drop-caret {
    margin-left:4px;

}

</style>
